import { ColumnsType } from "antd/lib/table";

import DataTable from "./DataTable";

import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";

function MyCarOrder({ myCarOrder }: { myCarOrder?: Array<Types.OrderDto> }) {
    const myCarOrderHistory: ColumnsType<Types.OrderDto> = [
        {
            align: "center",
            title: "번호",
            dataIndex: "num",
            width: "6%",
            render: (item, record, index) => <>{myCarOrder && myCarOrder.indexOf(record) + 1}</>,
        },
        {
            align: "center",
            title: "주문일",
            dataIndex: "createdDate",
        },
        {
            align: "center",
            title: "취소일",
            dataIndex: "canceledDate",
            render: (_, row) => <>{row.canceledDate || String.dash}</>,
        },
        {
            align: "center",
            title: "주문번호",
            dataIndex: "orderNo",
        },
        {
            align: "center",
            title: "다날주문번호",
            dataIndex: "impUid",
            render: (_, row) => <>{(row.payments && row.payments[0].paymentImp?.impUid) || String.dash}</>,
        },
        {
            align: "center",
            title: "차량타입",
            dataIndex: "carTypeName",
            render: (_, row) => <>{row.carType?.typeName || String.dash}</>,
        },
        {
            align: "center",
            title: "차량특장",
            dataIndex: "additionalCompany",
            render: (_, row) => <>{row.carType?.additionalCompany || String.dash}</>,
        },
        {
            align: "center",
            title: "차량보조금",
            dataIndex: "localSubsidy",
            render: (_, row) => <>{row.localSubsidy?.siGunGu?.siGunGuName || String.dash}</>,
        },
        {
            align: "center",
            title: "진행단계",
            dataIndex: "process",
            // TODO:  진행단계 set /// paymentImpDto - status??
            // render: (_, row) => <>{row.payments && row.payments[0].amount === 100000 ? "예약완료" : String.dash}</>,
        },
    ];

    return <DataTable hasScroll={false} columns={myCarOrderHistory} rowKey="orderNo" dataSource={myCarOrder} />;
}

export default MyCarOrder;
